module.exports = __webpack_public_path__ + "static/media/imperial-treasure.ee28f033.png";